import { Logger } from "../Logging/Logger";

export class ConsoleApplicationContext {
    public readonly logger: Logger;

    public constructor(logger: Logger) {
        this.logger = logger;
    }

    public setConsoleLoggingVerbosity(verboseLevel: number): void {
        this.logger.setConsoleLoggingVerbosity(verboseLevel);
    }

    public async waitForExit(): Promise<void> {
        return new Promise<void>(resolve => {
            process.on("SIGINT", () => {
                resolve();
            });
        });
    }
}
